export default {
  top_menu: [
    { name: "Utama", id: 0 },
    { name: "Tunjukkan Perniagaan", id: 1 },
    { name: "Memasak", id: 2 },
    { name: "Dasar", id: 3 },
    { name: "pedas", id: 4 },
    { name: "Masyarakat", id: 5 },
    { name: "Kesihatan", id: 6 },
  ],
  read_other: "Baca lagi",
  read_more: "Maklumat lanjut",
  not_found: "Tiada apa-apa Dijumpai",
  read_also: "Baca juga",
  copy_rights: "Copyright © 2019 «mixer-novostei.ru». Hak cipta terpelihara.",
  subscribe: "Langgan",

  thank_order: "TERIMA KASIH ATAS TEMPAHAN",
  specialist_contact:
    "Pakar kami akan menghubungi anda tidak lama lagi, tunggu panggilan kami.",
  attention: "Diskaun daripada rakan kongsi:",
  hurry:
    'Cepat, masa pengaktifan diskaun adalah terhad! Anda hanya mempunyai  <span id="time" class="time">30:00</span> minit untuk memilih salah satu daripada produk unik ini:',

  hour_ago1: "jam yang lalu",
  hour_ago2: "jam lalu",
  hour_ago3: "jam yang lalu",
  new_publications: "Penerbitan baharu",
  read: "Baca",
  today_at: "Hari ini di",
  author_names: ["Elena Klimova", "Maria Andreeva", "Irina Klimenko"],
  main_news: "Berita utama",
  leave_already:
    "Adakah anda sudah pergi? Tunggu, kami telah mengemas kini berita untuk anda",
  already_shared: "sudah dikongsi",
};
